import { cva, cx } from '@repo/panda/css';
import type { RecipeVariantProps } from '@repo/panda/types';
import type React from 'react';
import { forwardRef, type HTMLAttributes } from 'react';

const formStyles = cva({
    base: {
        display: 'flex',
        flexDirection: 'column',
    },
    variants: {
        spacing: {
            xs: { gap: '4' },
            sm: { gap: '8' },
            md: { gap: '12' },
            lg: { gap: '16' },
            xl: { gap: '24' },
        },
    },
    defaultVariants: {
        spacing: 'md',
    },
});

export type FormProps = HTMLAttributes<HTMLFormElement> &
    RecipeVariantProps<typeof formStyles> & {
        children: React.ReactNode;
        action?: string;
        method?: 'get' | 'post' | 'dialog';
        encType?: string;
        target?: string;
        autoComplete?: string;
        noValidate?: boolean;
        rel?: string;
        onSubmit?: (event: React.SubmitEvent<HTMLFormElement>) => void;
    };

export const Form = forwardRef<HTMLFormElement, FormProps>(
    (
        {
            children,
            spacing,
            className,
            onSubmit,
            action,
            method,
            encType,
            target,
            autoComplete,
            noValidate,
            rel,
            ...props
        },
        ref,
    ) => {
        return (
            <form
                ref={ref}
                className={cx(formStyles({ spacing }), className)}
                onSubmit={onSubmit}
                action={action}
                method={method}
                encType={encType}
                target={target}
                autoComplete={autoComplete}
                noValidate={noValidate}
                rel={rel}
                {...props}
            >
                {children}
            </form>
        );
    },
);
